package com.example.positionahead.model

import kotlinx.serialization.Serializable

@Serializable
data class WatchlistItem(
    val symbol: String,
    val addedDate: String? = null,
    val note: String? = null,
)

data class WatchlistEntry(
    val item: WatchlistItem,
    val quote: Quote?,
    val performance: SymbolPerformance? = null,
)
